import { render, staticRenderFns } from "./foam-type-stats.card.vue?vue&type=template&id=7a848adc&scoped=true&"
import script from "./foam-type-stats.card.vue?vue&type=script&lang=js&"
export * from "./foam-type-stats.card.vue?vue&type=script&lang=js&"
import style0 from "./foam-type-stats.card.vue?vue&type=style&index=0&id=7a848adc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a848adc",
  null
  
)

export default component.exports